// extracted by mini-css-extract-plugin
export default {"placeholderContent":"horizontal_parts_list__placeholderContent__zyAFW","placeholderLabel":"horizontal_parts_list__placeholderLabel__CQCmD"};